"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UIElementSizesEnum = void 0;
let UIElementSizesEnum = exports.UIElementSizesEnum = /*#__PURE__*/function (UIElementSizesEnum) {
  UIElementSizesEnum["Small"] = "small";
  UIElementSizesEnum["Medium"] = "medium";
  UIElementSizesEnum["Large"] = "large";
  return UIElementSizesEnum;
}({});